import { InjectionToken } from '@angular/core'

export const APP = new InjectionToken<string>('App')
export const DEPLOY_URL = new InjectionToken<string>('DeployUrl')
export const HUB_URL = new InjectionToken<string>('HubUrl')
export const LOCATION = new InjectionToken<Location>('Location')
export const MAX_CONCURRENT_QUERIES = new InjectionToken<number>('MaxConcurrentQueries', {
  providedIn: 'root',
  factory: () => 5,
})
export const WINDOW = new InjectionToken<Window>('Window')
